import { render, staticRenderFns } from "./moveTeaMain.vue?vue&type=template&id=fabd6152&scoped=true"
import script from "./moveTeaMain.vue?vue&type=script&lang=js"
export * from "./moveTeaMain.vue?vue&type=script&lang=js"
import style0 from "./moveTeaMain.vue?vue&type=style&index=0&id=fabd6152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd6152",
  null
  
)

export default component.exports